export default function (...args) {
  return args.slice(0, -1);
}
